import request from '../../../../../../setup/axios/request'
import requestNoAuth from '../../../../../../setup/axios/request-no-auth'
import requestFile from '../../../../../../setup/axios/request-file'
import {FilterModel} from '../../../../../pages/dashboard/components/SummaryHealthInsurances'

const lang = localStorage.getItem('i18nConfig')
const lang_r = lang ? JSON.parse(lang).selectedLang : 'VI'

export const searchAndPagingLocationNew = () => {
  let data = {
    LanguageCode: lang_r.toUpperCase(),
    Filter: {
      searchField: '',
      code: '',
      name: '',
    },
    OrderBy: [],
    PageIndex: 0,
    PageSize: -1,
    ShowTotal: false,
  }
  return request({
    url: '/api/v1/Selling/Configuration/Location/search-and-pagging',
    method: 'post',
    data: data,
  })
}
export const searchAndPagingLocationByCoverage = (coverage: string) => {
  return request({
    url: '/api/v1/Selling/AreaCountry/search-and-pagging-by-code?CompanyCode=TMIV&CoverageCode=' + coverage,
    method: 'post',
  })
}
export const searchAndPagingLocationDistrict = () => {
  let data = {
    LanguageCode: lang_r.toUpperCase(),
    Filter: {
      searchField: '',
      code: '',
      name: '',
    },
    OrderBy: [],
    PageIndex: 0,
    PageSize: -1,
    ShowTotal: false,
    ListFilter: [
      {
        propertyName: 'LocationType',
        operation: 0,
        value: '2',
        typeSearch: 0,
      },
    ],
  }
  return request({
    url: '/api/v1/Selling/Configuration/Location/search-and-pagging',
    method: 'post',
    data: data,
  })
}
export const searchAndPagingLocationProvince = () => {
  let data = {
    LanguageCode: lang_r.toUpperCase(),
    Filter: {
      searchField: '',
      code: '',
      name: '',
    },
    OrderBy: [],
    PageIndex: 0,
    PageSize: -1,
    ShowTotal: false,
    ListFilter: [
      {
        propertyName: 'LocationType',
        operation: 0,
        value: '1',
        typeSearch: 0,
      },
    ],
  }
  return request({
    url: '/api/v1/Selling/Configuration/Location/search-and-pagging',
    method: 'post',
    data: data,
  })
}
export const searchAndPagingLocationWard = () => {
  let data = {
    LanguageCode: lang_r.toUpperCase(),
    Filter: {
      searchField: '',
      code: '',
      name: '',
    },
    OrderBy: [],
    PageIndex: 0,
    PageSize: -1,
    ShowTotal: false,
    ListFilter: [
      {
        propertyName: 'LocationType',
        operation: 0,
        value: '3',
        typeSearch: 0,
      },
    ],
  }
  return request({
    url: '/api/v1/Selling/Configuration/Location/search-and-pagging',
    method: 'post',
    data: data,
  })
}

export const searchAndPagingBusinessProgram = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: '',
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/businessProgram/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}

export const checkPhanCap = (id: any, data: any) => {
  return request({
    url: '/api/v1/SellingStep/check-hierarchical?sellingContractId=' + id,
    method: 'post',
    data: data,
  })
}

export const searchAndPagingBank = (id: any) => {
  let dataFilter = {
    filter: {searchField: '', code: '', name: '', id: '', SearchType: 0},
    orderBy: [],
    pageIndex: 0,
    pageSize: -1,
    showTotal: false,
    listFilter: [{PropertyName: 'Code', Operation: 1, Value: id, TypeSearch: 0}],
  }
  return request({
    url: '/api/v1/Selling/BankInfors/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}

export const getListApproveConfig = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: '',
      code: '',
      name: '',
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/ConfigApprove/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}

export const searchAndPagingCurrency = (data: any) => {
  data = {
    filter: {
      searchField: '',
      code: '',
      name: '',
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Configuration/currency/search-and-pagging',
    method: 'post',
    data: data,
  })
}

export const searchAndPagingProduct = (
  data?: any,
  pageIndex?: number,
  pageSize?: number,
  listFilter?: any
) => {
  let dataFilter: any = {
    filter: {
      searchField: '',
      code: '',
      name: '',
      isGetConfigureField: true,
      applicationType: '2',
      contractSellingStep: 0,
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    listFilter: [],
    pageIndex: pageIndex ? pageIndex - 1 : 0,
    pageSize: pageSize ? pageSize : -1,
    showTotal: true,
  }

  if (data) {
    let obj: any = {
      propertyName: 'ProductCode',
      operation: 1,
      value: data,
    }
    dataFilter.listFilter.push(obj)
  }

  if (listFilter) {
    let obj: any = {
      propertyName: 'Name',
      operation: 6,
      value: listFilter,
    }
    dataFilter.listFilter.push(obj)
  }

  return request({
    url: '/api/v1/Selling/groupDomain/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}

export const step1AddUserSimultaneously = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step1-add-user-simultaneously',
    method: 'post',
    data: data,
  })
}

export const sellingSimultaneouslyComment = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/selling-simultaneously-comment',
    method: 'post',
    data: data,
  })
}

export const getSellingSimultaneouslyComment = (sellingContractId: any) => {
  let obj = {
    Includes: [],
    Filters: [
      {
        FieldName: 'RefId',
        Comparision: '=',
        FieldValue: sellingContractId,
      },
    ],
    Page: '1',
    PageSize: '100',
  }
  return request({
    url: '/api/v1/SellingStep/get-selling-simultaneously-comment',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const updateUserSimultaneously = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/update-user-simultaneously',
    method: 'post',
    data: data,
  })
}

export const step1GetUserSimultaneously = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step1-get-user-simultaneously?idContract=' + data,
    method: 'get',
  })
}

export const step2CreateContractPackageOption = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-create-contract-package-option',
    method: 'post',
    data: data,
  })
}

export const step2SaveWaiting = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-add-waiting-contractPackage',
    method: 'post',
    data: data,
  })
}

export const step2GetWaiting = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-get-waiting-contractPackage?idContract=' + data,
    method: 'get',
  })
}

export const step2GetContractPackageOption = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-get-contract-package-options?idContract=' + data,
    method: 'get',
  })
}

export const searchAndPagingContract = (data: any) => {
  let obj = {}
  if (data) {
    obj = {
      Filters: data.filter,
      Page: data.pageNum.toString(),
      PageSize: data.pageSize.toString(),
    }
  }
  return request({
    url: '/api/v1/SellingStep/step1-list-contract-new',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const searchAndPagingContractByInsured = (data: any) => {
  let obj = {}
  if (data) {
    obj = {
      Filters: data.filter,
      Page: data.pageNum.toString(),
      PageSize: data.pageSize.toString(),
    }
  }
  return request({
    url: '/api/v1/SellingStep/step1-list-contract-by-insured-info',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}
export const searchAndPagingContractDashboard = (data: any) => {
  let obj = {}
  if (data) {
    obj = {
      Filters: data.filter,
      Page: data.pageNum.toString(),
      PageSize: data.pageSize.toString(),
    }
  }
  return request({
    url: '/api/v1/SellingStep/get-data-dashboard-payment-schedule',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}


export const addConfigLDP = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/add-configLDP',
    method: 'post',
    data: data,
  })
}

export const getListConfigLDP = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/get-list-configLDP?IdContract=' + data,
    method: 'get',
  })
}

export const getListApprove = (data: string) => {
  return request({
    url: '/api/v1/Selling/ConfigApprove/search-and-pagging-user/' + data,
    method: 'get',
  })
}

export const getDataDashBoard = (data: FilterModel) => {
  return request({
    url: '/api/v1/SellingStep/get-data-dashboard',
    method: 'post',
    data: data,
  })
}

export const step1AddContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step1-add-contract',
    method: 'post',
    data: data,
  })
}

export const step1UpdateContractCurrency = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step1-update-contract-currency',
    method: 'post',
    data: data,
  })
}

export const step1GetContractById = (id: string) => {
  return request({
    url: '/api/v1/SellingStep/step1-contract-byid?id=' + id,
    method: 'get',
  })
}

export const step3ObjectInsuredListCode = (id: string) => {
  return request({
    url: '/api/v1/SellingStep/step3-objectInsured-list-code?idContract=' + id,
    method: 'get',
  })
}

export const step3ValidPeopleExcel = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/valid-people-excel',
    method: 'post',
    data: data,
  })
}

export const getPaymentIncurredShow = (id: any) => {
  return request({
    url: '/api/v1/Payment/get-payment-incurred-show?SellingContractId=' + id,
    method: 'get',
  })
}

export const step2UpdateContractCommission = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-update-contract-commission',
    method: 'post',
    data: data,
  })
}
export const step2GetContractCommission = (id: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-get-contract-commission?id=' + id,
    method: 'get',
  })
}

export const step1ListContractLog = (sellingContractId: string) => {
  let obj = {
    Includes: [],
    Filters: [
      {
        FieldName: 'Id',
        Comparision: '=',
        FieldValue: sellingContractId,
      },
    ],
    Page: '1',
    PageSize: '20',
  }
  return request({
    url: '/api/v1/SellingStep/step1-list-contract-log',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step1ListContractByObjectInsured = (sellingContractId: string) => {
  return request({
    url: '/api/v1/SellingStep/step1-all-renew-by-contract?IdContract=' + sellingContractId,
    method: 'get',
  })
}

export const step2ContractPackage = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-contractPackage',
    method: 'post',
    data: data,
  })
}

export const step2ContractPackageForLDP = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-contractPackage-forLDP?sellingContractId=' + data,
    method: 'get',
  })
}

export const getContractInvoice = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/contract-invoice?IdContract=' + data.idContract,
    method: 'get',
  })
}
export const createContractInvoice = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/create-contract-invoice',
    method: 'post',
    data: data,
  })
}

export const step2ContractPackageDiscount = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-contractPackage-discount',
    method: 'post',
    data: data,
  })
}

	
export const step2ContractPackageDiscountCommon = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-contract-package-discount-common',
    method: 'post',
    data: data,
  })
}

export const step2DeleteAllObjectInsuredByPackageCode = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-delete-all-objectInsured-by-packageCode',
    method: 'delete',
    data: data,
  })
}

export const step2ContractPackageDiscountByid = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-contractPackage-discount-by-package-id?id=' + data,
    method: 'get',
  })
}

export const step2GetContractPackage = (sellingContractId: string) => {
  let obj = {
    Page: '1',
    PageSize: '20',
    sorts: [
      {
        fieldName: 'Name',
        direction: 1,
      },
    ],
  }
  return request({
    url: '/api/v1/SellingStep/step2-contractPackage?id=' + sellingContractId,
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step2GetContractPackageByCode = (data: any) => {
  return request({
    url:
      '/api/v1/SellingStep/step2-contractPackage-by-code?code=' +
      data.code +
      '&sellingContractId=' +
      data.sellingContractId,
    method: 'get',
  })
}

export const step2CompletePackageQuotation = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-complete-package-quotation',
    method: 'post',
    data: data,
  })
}

export const step2CancelPackageQuotation = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-cancel-package-quotation',
    method: 'post',
    data: data,
  })
}

export const copyContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/copy-contract',
    method: 'post',
    data: data,
  })
}

export const step2SendMailNoticePM = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-send-mail-notice-pm',
    method: 'post',
    data: data,
  })
}

export const SignFile = (data: any) => {
  return request({
    url: '/api/v1/FileManager/sign-product-file',
    method: 'post',
    data: data,
  })
}

export const createSellingNotification = (data: any) => {
  return request({
    url: '/api/v1/Notification/create-selling-notification',
    method: 'post',
    data: data,
  })
}

export const PrintDocument = (data: any) => {
  return request({
    url:
      '/api/v1/Report/call-stored_multi_curs?id=' +
      data.id +
      '&type=' +
      data.Type +
      '&idDetails=' +
      (data.idDetails ? data.idDetails : '') +
      '&fileName=null' +
      '&groupdomainCode=PAL' +
      '&refID=' +
      data.refID + '&input6=' + (data?.input6 ? data.input6 : ''),
    method: 'get',
  })
}

export const DownloadPrintExcel = (data: any) => {
  return requestNoAuth({
    url:
      '/api/v1/Report/call-stored_multi_curs_report?type=' +
      data.type +
      '&fromDate=' +
      data.fromDate +
      '&toDate=' +
      data.toDate,
    method: 'get',
  })
}

export const Sendmail = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-sendmail',
    method: 'post',
    data: data,
  })
}

export const step2DeleteContractPackageByid = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-delete-contractPackage-byid',
    method: 'delete',
    data: data,
  })
}

export const step2ExportExcel = (data: any) => {
  return request({
    url: '/api/v1/Report/get-excel-packages?fileName=templatePackages',
    method: 'post',
    data: data,
  })
}

export const compareEndor = (data: any) => {
  return request({
    url:
      '/api/v1/SellingStep/step2-compareEndor?idFrist=' +
      data.idFrist +
      '&idSecond=' +
      data.idSecond,
    method: 'get',
  })
}

export const step2GetContractExtraData = (idContract: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-get-contract-extraData?idContract=' + idContract,
    method: 'get',
  })
}

export const step2CreateContractExtraData = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step2-create-contract-extraData',
    method: 'post',
    data: data,
  })
}

export const step2CopyPackage = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/copy-package',
    method: 'post',
    data: data,
  })
}

export const step1SendMailUserSimultaneously = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step1-send-mail-user-simultaneously',
    method: 'post',
    data: data,
  })
}

export const step4UpdateVoucher = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-update-voucher',
    method: 'post',
    data: data,
  })
}
export const viewFile = (data: any) => {
  let obj = {
    Filters: [
      {
        FieldName: 'RefId',
        Comparision: '==',
        FieldValue: data.RefID,
      },
      {
        FieldName: 'Id',
        Comparision: '==',
        FieldValue: data.Id,
      },
    ],
    Page: '1',
    PageSize: '20',
  }

  return request({
    url: '/api/v1/FileManager/view-file-upload',
    headers: {
      'x-query': JSON.stringify(obj),
    },
    method: 'get',
  })
}

export const getListFileUpload = (data: any) => {
  let obj = {
    Filters: [
      {
        FieldName: 'RefID',
        Comparision: '==',
        FieldValue: data,
      },
    ],
    Page: '1',
    PageSize: '20',
  }

  return request({
    url: '/api/v1/FileManager/get-list-file-upload',
    method: 'GET',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}
export const step2PackageUpload = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  return requestFile({
    url: '/api/v1/SellingStep/read-excel-package',
    method: 'post',
    data: formData,
  })
}

export const uploadExcelLossRatio = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  formData.append('customerCode', data.customerCode)
  return requestFile({
    url: '/api/v1/SellingStep/upload-excel-loss-ratio',
    method: 'post',
    data: formData,
  })
}

export const step3Upload = (data: any, type:any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  if(type == 'EXPAT')
  {
    return requestFile({
      url:
        '/api/v1/SellingStep/step3-objectInsured-list-excel-expat?sellingContractId=' +
        data.sellingContractId +
        '&packagesCode=' +
        data.packagesCode,
      method: 'post',
      data: formData,
    })
  }
  else
  {
    return requestFile({
      url:
        '/api/v1/SellingStep/step3-objectInsured-list-excel?sellingContractId=' +
        data.sellingContractId +
        '&packagesCode=' +
        data.packagesCode,
      method: 'post',
      data: formData,
    })
    
  }
}



export const step2Upload = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  return requestFile({
    url:
      '/api/v1/SellingStep/step3-objectInsured-list-excel?sellingContractId=' +
      data.sellingContractId +
      '&packagesCode=' +
      data.packagesCode,
    method: 'post',
    data: formData,
  })
}

export const uploadFile = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  formData.append('refId', data.refID)
  formData.append('idDetail', data.idDetail)
  formData.append('type', data.type)
  if (data?.referenceObjectId) formData.append('referenceObjectId', data.referenceObjectId)
  if (data?.isConfigLandingPage) formData.append('isConfigLandingPage', data.isConfigLandingPage)
  if (data?.fileName) {
    formData.append('fileName', data?.fileName)
  } else formData.append('fileName', data.file.name)
  formData.append('applicationType', '1')

  return requestFile({
    url: '/api/v1/FileManager/upload-file',
    method: 'post',
    data: formData,
  })
}

export const pricingGetListPackage = (code: string, productType: string) => {
  return request({
    url:
      '/api/v1/Pricing/get-list-package?ProgramCode=' +
      code +
      '&ProductCode=' +
      productType +
      '&languageCode=' +
      lang_r.toUpperCase(),
    method: 'get',
  })
}

export const getPackageAdditionalCondition = (packageId: any) => {
  return request({
    url: '/api/v1/Pricing/get-package-additional-condition?packageId=' + packageId,
    method: 'get',
  })
}

export const pricingPackageInfo = (code: string, language?: string) => {
  return request({
    url: '/api/v1/Pricing/package?Code=' + code + '&languageCode=' + (language ? language?.toUpperCase() : lang_r.toUpperCase()),
    method: 'get',
  })
}

export const step3ObjectInsuredDetailsAdd = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step3-objectInsured-details-add',
    method: 'post',
    data: data,
  })
}

export const step3GetObjectInsuredList = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }

  return request({
    url: '/api/v1/SellingStep/step3-objectInsured-list?id=' + data.sellingContractId,
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step3GetObjectInsuredById = (data: any) => {
  return request({
    url:
      '/api/v1/SellingStep/step3-objectInsured-byid?idContract=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const getLinkQrcodeContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/get-link-qrcode-contract?idContract=' + data,
    method: 'get',
  })
}

export const getLinkQrcodeRiskAssessment = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/get-link-qrcode-risk-assessment?idContract=' + data,
    method: 'get',
  })
}

export const synthesisContractRenew = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/synthesis-contract-renew',
    method: 'post',
    data: data,
  })
}

export const step3GetObjectInsuredByIdentity = (data: any) => {
  return request({
    url:
      '/api/v1/SellingStep/step3-objectInsured-by-identifi?identifi=' +
      data.identifi +
      '&taxNumber=' +
      data.taxNumber +
      '&contractNumber=' +
      data.contractNumber,
    method: 'get',
  })
}

export const step3DeleteObjectInsuredByid = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step3-delete-objectInsured-byid/' + data.id.objectInsuredId,
    method: 'delete',
  })
}

export const step3DeleteObjectInsured = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step3-delete-objectInsured',
    method: 'post',
    data: data,
  })
}

export const step3TerminateObjectInsured = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step3-terminate-objectInsured',
    method: 'post',
    data: data,
  })
}

export const calculatorFeeHelthCare = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-helthCare',
    method: 'post',
    data: data,
  })
}

export const step4GetContractByID = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-contract-byid?id=' + data.id,
    method: 'get',
  })
}

export const updateContractPaymentSchedule = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/update-contract-payment-schedule',
    method: 'post',
    data: data,
  })
}

export const step3CalculateFee = (data: any) => {
  return request({
    url: '/api/v1/Pricing/caculator-fee-car-step3',
    method: 'post',
    data: data,
  })
}

export const caculatorFeeRemaining = (data: any) => {
  return request({
    url: '/api/v1/Pricing/caculator-fee-remaining',
    method: 'post',
    data: data,
  })
}

export const caculatorFeeHelthCareDiscount = (data: any) => {
  return request({
    url: '/api/v1/Pricing/caculator-fee-helthCare-discount',
    method: 'post',
    data: data,
  })
}

export const step4UpdateContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-update-contract',
    method: 'post',
    data: data,
  })
}

export const step4CreateEdorsementByTreaty = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-create-edorsement-byTreaty',
    method: 'post',
    data: data,
  })
}

export const step4CreateEdorsement = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-create-edorsement',
    method: 'post',
    data: data,
  })
}

export const step4SignContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/sign-contract',
    method: 'post',
    data: data,
  })
}

export const step4SuccessContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-success-contract',
    method: 'post',
    data: data,
  })
}

export const addLossRatio = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/add-lossRatio',
    method: 'post',
    data: data,
  })
}

export const getLossRatio = (contractId: any, customerCode: string) => {
  if (contractId && contractId?.includes('new -')) contractId = 0
  return request({
    url:
      '/api/v1/SellingStep/get-lossRatio?IdContract=' +
      contractId +
      '&custormerCode=' +
      customerCode,
    method: 'get',
  })
}

export const deleteLossRatio = (id: any) => {
  return request({
    url:
      '/api/v1/SellingStep/delete-loss-ratio/' + id,
    method: 'delete',
  })
}

export const deleteListLossRatio = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/delete-list-loss-ratio',
    method: 'post',
    data: data,
  })
}

export const renewContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/sellingContract-renew',
    method: 'post',
    data: data,
  })
}

export const step4CancelSuccessContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-cancel-success-contract',
    method: 'post',
    data: data,
  })
}

export const step4AddCoInsurance = (data: any) => {
  return request({
    url: '/api/v1/CoAndReinsurence/add-co-insurance',
    method: 'post',
    data: data,
  })
}

export const step4GetCoInsurance = (sellingContractId: string) => {
  let obj = {
    Page: '1',
    PageSize: '20',
    sorts: [
      {
        fieldName: 'SellingContractId',
        direction: sellingContractId,
      },
    ],
  }
  return request({
    url: '/api/v1/CoAndReinsurence/get-co-insurance?id=' + sellingContractId,
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step4AddReinsurance = (data: any) => {
  return request({
    url: '/api/v1/CoAndReinsurence/add-Reinsurance',
    method: 'post',
    data: data,
  })
}

export const step4GetReinsurance = (sellingContractId: string) => {
  let obj = {
    Page: '1',
    PageSize: '20',
    sorts: [
      {
        fieldName: 'SellingContractId',
        direction: sellingContractId,
      },
    ],
  }
  return request({
    url: '/api/v1/CoAndReinsurence/get-Reinsurance?id=' + sellingContractId,
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const getListCoReInsuredBenefits = (sellingContractId: any) => {
  return request({
    url:
      '/api/v1/CoAndReinsurence/get-list-co-re-insurance-benefits?idContract=' + sellingContractId,
    method: 'get',
  })
}

export const getListBenefitsChecked = (sellingContractId: any) => {
  return request({
    url: '/api/v1/SellingStep/get-list-benefits-checked?sellingContractId=' + sellingContractId,
    method: 'get',
  })
}

export const step1DeleteContractById = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step1-delete-contract-byid/' + data,
    method: 'delete',
  })
}

export const createContractByTreaty = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/create-contract-by-treaty',
    method: 'post',
    data: data,
  })
}

export const accpectContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-success-contract-multi',
    method: 'post',
    data: data,
  })
}

export const cancelContractPaymentSalary = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-cancel-payment-salary-multi',
    method: 'post',
    data: data,
  })
}

export const step3ObjectInsuredTempAdd = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/objectInsured-temp-add',
    method: 'post',
    data: data,
  })
}

export const step3SubmitObjectInsuredExcel = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/submit-objectInsured-excel',
    method: 'post',
    data: data,
  })
}

export const exportReport = (data: any) => {
  return request({
    url: '/api/v1/Report/call-stored_multi_curs_report?' + data,
    method: 'get',
  })
}

export const exportReportObjectInsured = (data: any) => {
  return request({
    url: '/api/v1/Report/get-export-data?' + data,
    method: 'get',
  })
}

export const getListEndorNote = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/get-list-endor-note?IdContract=' + data,
    method: 'get',
  })
}

export const searchAndPagingCareer = () => {
  let data = {
    languageCode: 'string',
    filter: {
      searchField: '',
      code: '',
      name: '',
    },
    orderBy: [
      {
        fieldName: 'string',
        direction: 0,
      },
    ],
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
    listFilter: [],
  }
  return request({
    url: '/api/v1/Selling/Career/search-and-pagging',
    method: 'post',
    data: data,
  })
}

export const searchAndPagingReinsuranceCompany = () => {
  let data = {
    languageCode: 'string',
    filter: {
      searchField: '',
      code: '',
      name: '',
    },
    orderBy: [
      {
        fieldName: 'string',
        direction: 0,
      },
    ],
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
    listFilter: [],
  }
  return request({
    url: '/api/v1/Selling/ReinsuranceCompany/search-and-pagging',
    method: 'post',
    data: data,
  })
}

export const deleteContractByID = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step1-delete-contract-byid/' + data.idContract,
    method: 'delete',
  })
}

export const validateContractForPayment = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/validate-contract-for-payment-secure',
    method: 'post',
    data: data,
  })
}

export const getContractPayee = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/get-contract-payee?IdContract=' + data.idContract,
    method: 'get',
  })
}
export const createContractPayee = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/create-contract-payee',
    method: 'post',
    data: data,
  })
}
export const getbusinessProgramPayeeNote = (businessProgram: any) => {
  return request({
    url: 'api/v1/Selling/getbusinessProgramPayeeNote/' + businessProgram,
    method: 'get',
  })
}

export const InsuranceType: any = [
  {
    type: 'P_I',
    text: 'Bảo hiểm con người',
  },
  {
    type: 'HOME_I',
    text: 'Bảo hiểm nhà tư nhân',
  },
  {
    type: 'MOTO_I',
    text: 'Bảo hiểm xe gắn máy',
  },
  {
    type: 'AUTO_I',
    text: 'Bảo hiểm ô tô',
  },
  {
    type: 'MIX_I',
    text: 'Bảo hiểm hỗn hợp',
  },
]

export const Bussiness: any = [
  {label: 'Trồng lúa', value: '0111'},
  {label: 'Trồng ngô và cây lương thực có hạt khác', value: '0112'},
  {label: 'Trồng cây lấy củ có chất bột ', value: '0113'},
  {label: 'Trồng cây mía', value: '0114'},
  {label: 'Trồng cây thuốc lá, thuốc lào', value: '0115'},
  {label: 'Trồng cây lấy sợi', value: '0116'},
  {label: 'Trồng cây có hạt chứa dầu', value: '0117'},
  {label: 'Trồng rau, đậu các loại và trồng hoa', value: '0118'},
  {label: 'Trồng cây hàng năm khác ', value: '0119'},
  {label: 'Trồng cây ăn quả', value: '0121'},
  {label: 'Trồng cây lấy quả chứa dầu', value: '0122'},
  {label: 'Trồng cây điều', value: '0123'},
  {label: 'Trồng cây hồ tiêu', value: '0124'},
  {label: 'Trồng cây cao su', value: '0125'},
  {label: 'Trồng cây cà phê', value: '0126'},
  {label: 'Trồng cây chè ', value: '0127'},
  {label: 'Trồng cây gia vị, cây dược liệu, cây hương liệu lâu năm', value: '0128'},
  {label: 'Trồng cây lâu năm  khác ', value: '0129'},
  {label: 'Nhân và chăm sóc cây giống hàng năm', value: '0131'},
  {label: 'Nhân và chăm sóc cây giống lâu năm', value: '0132'},
  {label: 'Chăn nuôi trâu, bò và sản xuất giống trâu, bò', value: '0141'},
  {label: 'Chăn nuôi ngựa, lừa, la và sản xuất giống ngựa, lừa', value: '0142'},
  {label: 'Chăn nuôi dê, cừu và sản xuất giống dê, cừu, hươu, nai', value: '0144'},
  {label: 'Chăn nuôi lợn và sản xuất giống lợn', value: '0145'},
  {label: 'Chăn nuôi gia cầm', value: '0146'},
  {label: 'Chăn nuôi khác ', value: '0149'},
  {label: 'Trồng trọt, chăn nuôi hỗn hợp', value: '0150'},
  {label: 'Hoạt động dịch vụ trồng trọt ', value: '0161'},
  {label: 'Hoạt động dịch vụ chăn nuôi ', value: '0162'},
  {label: 'Hoạt động dịch vụ sau thu hoạch', value: '0163'},
  {label: 'Xử lý hạt giống để nhân giống', value: '0164'},
  {label: 'Săn bắt, đánh bẫy và hoạt động dịch vụ có liên quan', value: '0170'},
  {label: 'Trồng rừng, chăm sóc rừng và ươm giống cây lâm nghiệp', value: '0210'},

  {label: 'Khai thác lâm sản trừ gỗ', value: '0231'},
  {label: 'Thu nhặt lâm sản trừ gỗ', value: '0232'},
  {label: 'Hoạt động dịch vụ lâm nghiệp', value: '0240'},
  {label: 'Khai thác thuỷ sản biển', value: '0311'},
  {label: 'Khai thác thuỷ sản nội địa', value: '0312'},
  {label: 'Nuôi trồng thuỷ sản biển', value: '0321'},

  {label: 'Nuôi trồng thuỷ sản nội địa', value: '0322'},

  {label: 'Khai thác và thu gom than cứng', value: '0510'},
  {label: 'Khai thác và thu gom than non', value: '0520'},
  {label: 'Khai thác dầu thô', value: '0610'},
  {label: 'Khai thác khí đốt tự nhiên', value: '0620'},
  {label: 'Khai thác quặng sắt', value: '0710'},
  {label: 'Khai thác quặng uranium và quặng thorium', value: '0721'},
  {label: 'Khai thác quặng kim loại khác không chứa sắt ', value: '0722'},
  {label: 'Khai thác quặng kim loại quý hiếm ', value: '0730'},
  {label: 'Khai thác đá, cát, sỏi, đất sét ', value: '0810'},
  {label: 'Khai thác khoáng hoá chất và khoáng phân bón', value: '0891'},
  {label: 'Khai thác và thu gom than bùn', value: '0892'},
  {label: 'Khai thác muối', value: '0893'},
  {label: 'Khai khoáng khác chưa được phân vào đâu', value: '0899'},
  {label: 'Hoạt động dịch vụ hỗ trợ khai thác dầu thô và khí tự nhiên', value: '0910'},
  {label: 'Hoạt động dịch vụ hỗ trợ khai khoáng khác', value: '0990'},
  {label: 'Chế biến, bảo quản thịt và các sản phẩm từ thịt', value: '1010'},
  {label: 'Chế biến, bảo quản thuỷ sản và các sản phẩm từ thuỷ sản', value: '1020'},
  {label: 'Chế biến và bảo quản rau quả', value: '1030'},
  {label: 'Sản xuất dầu, mỡ động, thực vật', value: '1040'},
  {label: 'Chế biến sữa và các sản phẩm từ sữa', value: '1050'},
  {label: 'Xay xát và sản xuất bột thô', value: '1061'},
  {label: 'Sản xuất tinh bột và các sản phẩm từ tinh bột', value: '1062'},
  {label: 'Sản xuất các loại bánh từ bột', value: '1071'},
  {label: 'Sản xuất đường', value: '1072'},
  {label: 'Sản xuất ca cao, sôcôla và bánh kẹo', value: '1073'},
  {label: 'Sản xuất mì ống, mỳ sợi và sản phẩm tương tự', value: '1074'},
  {label: 'Sản xuất món ăn, thức ăn chế biến sẵn', value: '1075'},
  {label: 'Sản xuất chè', value: '1076'},
  {label: 'Sản xuất cà phê', value: '1077'},
  {label: 'Sản xuất thực phẩm khác chưa được phân vào đâu', value: '1079'},
  {label: 'Sản xuất thức ăn gia súc, gia cầm và thuỷ sản', value: '1080'},
  {label: 'Chưng, tinh cất và pha chế các loại rượu mạnh', value: '1101'},
  {label: 'Sản xuất rượu vang', value: '1102'},
  {label: 'Sản xuất bia và mạch nha ủ men bia', value: '1103'},
  {label: 'Sản xuất đồ uống không cồn, nước khoáng', value: '1104'},
  {label: 'Sản xuất sản phẩm thuốc lá', value: '1200'},
  {label: 'Sản xuất sợi', value: '1311'},
  {label: 'Sản xuất vải dệt thoi', value: '1312'},
  {label: 'Hoàn thiện sản phẩm dệt', value: '1313'},
  {label: 'Sản xuất vải dệt kim, vải đan móc và vải không dệt khác', value: '1391'},
  {label: 'Sản xuất hàng dệt sẵn (trừ trang phục)', value: '1392'},
  {label: 'Sản xuất thảm, chăn, đệm', value: '1393'},
  {label: 'Sản xuất các loại dây bện và lưới', value: '1394'},
  {label: 'Sản xuất các loại hàng dệt khác chưa được phân vào đâu', value: '1399'},
  {label: 'May trang phục (trừ trang phục từ da lông thú)', value: '1410'},
  {label: 'Sản xuất sản phẩm từ da lông thú', value: '1420'},
  {label: 'Sản xuất trang phục dệt kim, đan móc', value: '1430'},
  {label: 'Thuộc, sơ chế da; sơ chế và nhuộm da lông thú', value: '1511'},
  {label: 'Sản xuất vali, túi xách và các loại tương tự, sản xuất yên đệm', value: '1512'},
  {label: 'Sản xuất giày, dép', value: '1520'},
  {label: 'Cưa, xẻ, bào gỗ và bảo quản gỗ', value: '1610'},
  {label: 'Sản xuất gỗ dán, gỗ lạng, ván ép và ván mỏng khác', value: '1621'},
  {label: 'Sản xuất đồ gỗ xây dựng', value: '1622'},
  {label: 'Sản xuất bao bì bằng gỗ', value: '1623'},
  {
    label:
      'Sản xuất sản phẩm khác từ gỗ; sản xuất sản phẩm từ tre, nứa, rơm, rạ và vật liệu tết bện ',
    value: '1629',
  },
  {label: 'Sản xuất bột giấy, giấy và bìa', value: '1701'},
  {label: 'Sản xuất giấy nhăn, bìa nhăn, bao bì từ giấy và bìa', value: '1702'},
  {label: 'Sản xuất các sản phẩm khác từ giấy và bìa chưa được phân vào đâu ', value: '1709'},
  {label: 'In ấn', value: '1811'},
  {label: 'Dịch vụ liên quan đến in', value: '1812'},
  {label: 'Sao chép bản ghi các loại', value: '1820'},
  {label: 'Sản xuất than cốc', value: '1910'},
  {label: 'Sản xuất sản phẩm dầu mỏ tinh chế', value: '1920'},
  {label: 'Sản xuất hoá chất cơ bản', value: '2011'},
  {label: 'Sản xuất phân bón và hợp chất ni tơ', value: '2012'},
  {label: 'Sản xuất plastic và cao su tổng hợp dạng nguyên sinh', value: '2013'},
  {label: 'Sản xuất thuốc trừ sâu và sản phẩm hoá chất khác dùng trong nông nghiệp', value: '2021'},
  {
    label: 'Sản xuất sơn, véc ni và các chất sơn, quét tương tự; sản xuất mực in và ma tít',
    value: '2022',
  },
  {label: 'Sản xuất mỹ phẩm, xà phòng, chất tẩy rửa, làm bóng và chế phẩm vệ sinh', value: '2023'},
  {label: 'Sản xuất sản phẩm hoá chất khác chưa được phân vào đâu', value: '2029'},
  {label: 'Sản xuất sợi nhân tạo', value: '2030'},
  {label: 'Sản xuất thuốc, hoá dược và dược liệu', value: '2100'},
  {label: 'Sản xuất săm, lốp cao su; đắp và tái chế lốp cao su', value: '2211'},
  {label: 'Sản xuất sản phẩm khác từ cao su', value: '2219'},
  {label: 'Sản xuất sản phẩm từ plastic', value: '2220'},
  {label: 'Sản xuất thuỷ tinh và sản phẩm từ thuỷ tinh', value: '2310'},
  {label: 'Sản xuất sản phẩm chịu lửa', value: '2391'},
  {label: 'Sản xuất vật liệu xây dựng từ đất sét', value: '2392'},
  {label: 'Sản xuất sản phẩm gốm sứ khác', value: '2393'},
  {label: 'Sản xuất xi măng, vôi và thạch cao', value: '2394'},
  {label: 'Sản xuất bê tông và các sản phẩm từ bê tông, xi măng và thạch cao', value: '2395'},
  {label: 'Cắt tạo dáng và hoàn thiện đá', value: '2396'},
  {
    label: 'Sản xuất sản phẩm từ chất khoáng phi kim loại khác chưa được phân vào đâu',
    value: '2399',
  },
  {label: 'Sản xuất sắt, thép, gang', value: '2410'},
  {label: 'Sản xuất kim loại quý và kim loại màu', value: '2420'},
  {label: 'Đúc sắt, thép', value: '2431'},
  {label: 'Đúc kim loại màu', value: '2432'},
  {label: 'Sản xuất các cấu kiện kim loại ', value: '2511'},
  {label: 'Sản xuất thùng, bể chứa và dụng cụ chứa đựng bằng kim loại', value: '2512'},
  {label: 'Sản xuất nồi hơi (trừ nồi hơi trung tâm)', value: '2513'},
  {label: 'Sản xuất vũ khí và đạn dược', value: '2520'},
  {label: 'Rèn, dập, ép và cán kim loại; luyện bột kim loại', value: '2591'},
  {label: 'Gia công cơ khí; xử lý và tráng phủ kim loại', value: '2592'},
  {label: 'Sản xuất dao kéo, dụng cụ cầm tay và đồ kim loại thông dụng', value: '2593'},
  {label: 'Sản xuất sản phẩm khác bằng kim loại chưa được phân vào đâu', value: '2599'},
  {label: 'Sản xuất linh kiện điện tử', value: '2610'},
  {label: 'Sản xuất máy vi tính và thiết bị ngoại vi của máy vi tính', value: '2620'},
  {label: 'Sản xuất thiết bị truyền thông', value: '2630'},
  {label: 'Sản xuất sản phẩm điện tử dân dụng', value: '2640'},
  {label: 'Sản xuất thiết bị đo lường, kiểm tra, định hướng và điều khiển', value: '2651'},
  {label: 'Sản xuất đồng hồ', value: '2652'},
  {label: 'Sản xuất thiết bị bức xạ, thiết bị điện tử trong y học, điện liệu pháp', value: '2660'},
  {label: 'Sản xuất thiết bị và dụng cụ quang học', value: '2670'},
  {label: 'Sản xuất băng, đĩa từ tính và quang học', value: '2680'},
  {
    label: 'Sản xuất mô tơ, máy phát, biến thế điện, thiết bị phân phối và điều khiển điện',
    value: '2710',
  },
  {label: 'Sản xuất pin và ắc quy', value: '2720'},
  {label: 'Sản xuất dây cáp, sợi cáp quang học', value: '2731'},
  {label: 'Sản xuất dây, cáp điện và điện tử khác', value: '2732'},
  {label: 'Sản xuất thiết bị dây dẫn điện các loại', value: '2733'},
  {label: 'Sản xuất thiết bị điện chiếu sáng', value: '2740'},
  {label: 'Sản xuất đồ điện dân dụng', value: '2750'},
  {label: 'Sản xuất thiết bị điện khác', value: '2790'},
  {label: 'Sản xuất động cơ, tua bin (trừ động cơ máy bay, ô tô, mô tô và xe máy)', value: '2811'},
  {label: 'Sản xuất thiết bị sử dụng năng lượng chiết lưu ', value: '2812'},
  {label: 'Sản xuất máy bơm, máy nén, vòi và van khác', value: '2813'},
  {
    label: 'Sản xuất bi, bánh răng, hộp số, các bộ phận điều khiển và truyền chuyển động',
    value: '2814',
  },
  {label: 'Sản xuất lò nướng, lò luyện và lò nung', value: '2815'},
  {label: 'Sản xuất các thiết bị nâng, hạ và bốc xếp', value: '2816'},
  {
    label:
      'Sản xuất máy móc và thiết bị văn phòng (trừ máy vi tính và thiết bị ngoại vi của máy vi tính)',
    value: '2817',
  },
  {label: 'Sản xuất dụng cụ cầm tay chạy bằng mô tơ hoặc khí nén ', value: '2818'},
  {label: 'Sản xuất máy thông dụng khác', value: '2819'},
  {label: 'Sản xuất máy nông nghiệp và lâm nghiệp', value: '2821'},
  {label: 'Sản xuất máy công cụ và máy tạo hình kim loại', value: '2822'},
  {label: 'Sản xuất máy luyện kim', value: '2823'},
  {label: 'Sản xuất máy khai thác mỏ và xây dựng', value: '2824'},
  {label: 'Sản xuất máy chế biến thực phẩm, đồ uống và thuốc lá', value: '2825'},
  {label: 'Sản xuất máy cho ngành dệt, may và da', value: '2826'},
  {label: 'Sản xuất máy chuyên dụng khác', value: '2829'},
  {label: 'Sản xuất ô tô và xe có động cơ khác', value: '2910'},
  {label: 'Sản xuất thân xe ô tô và xe có động cơ khác, rơ moóc và bán rơ moóc', value: '2920'},
  {label: 'Sản xuất phụ tùng và bộ phận phụ trợ cho xe ô tô và xe có động cơ khác', value: '2930'},
  {label: 'Đóng tàu và cấu kiện nổi', value: '3011'},
  {label: 'Đóng thuyền, xuồng thể thao và giải trí', value: '3012'},
  {label: 'Sản xuất đầu máy xe lửa, xe điện và toa xe', value: '3020'},
  {label: 'Sản xuất máy bay, tàu vũ trụ và máy móc liên quan', value: '3030'},
  {label: 'Sản xuất xe cơ giới chiến đấu dùng trong quân đội', value: '3040'},
  {label: 'Sản xuất mô tô, xe máy', value: '3091'},
  {label: 'Sản xuất xe đạp và xe cho người khuyết tật', value: '3092'},
  {label: 'Sản xuất phương tiện và thiết bị vận tải khác chưa được phân vào đâu', value: '3099'},
  {label: 'Sản xuất giường, tủ, bàn, ghế', value: '3100'},
  {label: 'Sản xuất đồ kim hoàn và chi tiết liên quan', value: '3211'},
  {label: 'Sản xuất đồ giả kim hoàn và chi tiết liên quan', value: '3212'},
  {label: 'Sản xuất nhạc cụ ', value: '3220'},
  {label: 'Sản xuất dụng cụ thể dục, thể thao', value: '3230'},
  {label: 'Sản xuất đồ chơi, trò chơi', value: '3240'},
  {
    label: 'Sản xuất thiết bị, dụng cụ y tế, nha khoa, chỉnh hình và phục hồi chức năng',
    value: '3250',
  },
  {label: 'Sản xuất khác chưa được phân vào đâu', value: '3290'},
  {label: 'Sửa chữa các sản phẩm kim loại đúc sẵn', value: '3311'},
  {label: 'Sửa chữa máy móc, thiết bị', value: '3312'},
  {label: 'Sửa chữa thiết bị điện tử và quang học', value: '3313'},
  {label: 'Sửa chữa thiết bị điện', value: '3314'},
  {
    label:
      'Sửa chữa và bảo dưỡng phương tiện vận tải (trừ ô tô, mô tô, xe  máy và xe có động cơ khác)',
    value: '3315',
  },
  {label: 'Sửa chữa thiết bị khác', value: '3319'},
  {label: 'Lắp đặt máy móc và thiết bị công nghiệp', value: '3320'},
  {label: 'Sản xuất điện', value: '3511'},
  {label: 'Truyền tải và phân phối điện', value: '3512'},
  {label: 'Sản xuất khí đốt, phân phối nhiên liệu khí bằng đường ống', value: '3520'},
  {
    label: 'Sản xuất, phân phối hơi nước, nước nóng, điều hoà không khí và sản xuất nước đá',
    value: '3530',
  },
  {label: 'Khai thác, xử lý và cung cấp nước', value: '3600'},
  {label: 'Thoát nước và xử lý nước thải', value: '3700'},
  {label: 'Thu gom rác thải không độc hại', value: '3811'},
  {label: 'Thu gom rác thải độc hại', value: '3812'},
  {label: 'Xử lý và tiêu huỷ rác thải không độc hại', value: '3821'},
  {label: 'Xử lý và tiêu huỷ rác thải độc hại', value: '3822'},
  {label: 'Tái chế phế liệu', value: '3830'},
  {label: 'Xử lý ô nhiễm và hoạt động quản lý chất thải khác', value: '3900'},
  {label: 'Xây dựng nhà để ở ', value: '4101'},
  {label: 'Xây dựng nhà không để ở', value: '4102'},
  {label: 'Xây dựng công trình đường sắt ', value: '4211'},
  {label: 'Xây dựng công trình đường bộ ', value: '4212'},
  {label: 'Xây dựng công trình điện', value: '4221'},
  {label: 'Xây dựng công trình cấp, thoát nước', value: '4222'},
  {label: 'Xây dựng công trình viễn thông, thông tin liên lạc', value: '4223'},
  {label: 'Xây dựng công trình công ích khác', value: '4229'},
  {label: 'Xây dựng công trình thủy', value: '4291'},
  {label: 'Xây dựng công trình khai khoáng', value: '4292'},
  {label: 'Xây dựng công trình chế biến, chế tạo', value: '4293'},
  {label: 'Xây dựng công trình kỹ thuật dân dụng khác', value: '4299'},
  {label: 'Phá dỡ', value: '4311'},
  {label: 'Chuẩn bị mặt bằng', value: '4312'},
  {label: 'Lắp đặt hệ thống điện', value: '4321'},
  {label: 'Lắp đặt hệ thống cấp, thoát nước, hệ thống sưởi và điều hoà không khí', value: '4322'},
  {label: 'Lắp đặt hệ thống xây dựng khác', value: '4329'},
  {label: 'Hoàn thiện công trình xây dựng', value: '4330'},
  {label: 'Hoạt động xây dựng chuyên dụng khác', value: '4390'},
  {label: 'Bán buôn ô tô và xe có động cơ khác ', value: '4511'},
  {label: 'Bán lẻ ô tô con (loại 9 chỗ ngồi trở xuống)', value: '4512'},
  {label: 'Đại lý ô tô và xe có động cơ khác', value: '4513'},
  {label: 'Bảo dưỡng, sửa chữa ô tô và xe có động cơ khác', value: '4520'},
  {label: 'Bán phụ tùng và các bộ phận phụ trợ của ô tô và xe có động cơ khác', value: '4530'},
  {label: 'Bán mô tô, xe máy', value: '4541'},
  {label: 'Bảo dưỡng và sửa chữa mô tô, xe máy', value: '4542'},
  {label: 'Bán phụ tùng và các bộ phận phụ trợ của mô tô, xe máy', value: '4543'},
  {label: 'Đại lý, môi giới, đấu giá hàng hóa', value: '4610'},
  {label: 'Bán buôn nông, lâm sản nguyên liệu (trừ gỗ, tre, nứa) và động vật sống', value: '4620'},
  {label: 'Bán buôn gạo, lúa mỳ, hạt ngũ cốc khác, bột mỳ', value: '4631'},

  {label: 'Bán buôn thực phẩm', value: '4632'},
  {label: 'Bán buôn đồ uống', value: '4633'},
  {label: 'Bán buôn sản phẩm thuốc lá, thuốc lào ', value: '4634'},
  {label: 'Bán buôn vải, hàng may mặc, giày dép', value: '4641'},
  {label: 'Bán buôn đồ dùng khác cho gia đình', value: '4649'},
  {label: 'Bán buôn máy vi tính, thiết bị ngoại vi và phần mềm', value: '4651'},
  {label: 'Bán buôn thiết bị và linh kiện điện tử, viễn thông', value: '4652'},
  {label: 'Bán buôn máy móc, thiết bị và phụ tùng máy nông nghiệp ', value: '4653'},
  {label: 'Bán buôn máy móc, thiết bị và phụ tùng máy khác ', value: '4659'},
  {label: 'Bán buôn nhiên liệu rắn, lỏng, khí và các sản phẩm liên quan', value: '4661'},
  {label: 'Bán buôn kim loại và quặng kim loại', value: '4662'},
  {label: 'Bán buôn vật liệu, thiết bị lắp đặt khác trong xây dựng', value: '4663'},
  {label: 'Bán buôn chuyên doanh khác chưa được phân vào đâu', value: '4669'},
  {label: 'Bán buôn tổng hợp ', value: '4690'},
  {
    label:
      'Bán lẻ lương thực, thực phẩm, đồ uống, thuốc lá, thuốc lào chiếm tỷ trọng lớn trong các cửa hàng kinh doanh tổng hợp ',
    value: '4711',
  },
  {label: 'Bán lẻ  khác trong các cửa hàng kinh doanh tổng hợp ', value: '4719'},
  {label: 'Bán lẻ lương thực trong các cửa hàng chuyên doanh', value: '4721'},
  {label: 'Bán lẻ thực phẩm trong các cửa hàng chuyên doanh', value: '4722'},
  {label: 'Bán lẻ đồ uống trong các cửa hàng chuyên doanh', value: '4723'},
  {label: 'Bán lẻ sản phẩm thuốc lá, thuốc lào trong các cửa hàng chuyên doanh', value: '4724'},
  {label: 'Bán lẻ nhiên liệu động cơ trong các cửa hàng chuyên doanh', value: '4730'},
  {
    label:
      'Bán lẻ máy vi tính, thiết bị ngoại vi, phần mềm và thiết bị viễn thông trong các cửa hàng chuyên doanh',
    value: '4741',
  },
  {label: 'Bán lẻ thiết bị nghe nhìn trong các cửa hàng chuyên doanh', value: '4742'},
  {
    label: 'Bán lẻ vải, len, sợi, chỉ khâu và hàng dệt khác trong các cửa hàng chuyên doanh',
    value: '4751',
  },
  {
    label:
      'Bán lẻ đồ ngũ kim, sơn, kính và thiết bị lắp đặt khác trong xây dựng trong các cửa hàng chuyên doanh',
    value: '4752',
  },
  {
    label:
      'Bán lẻ thảm, đệm, chăn, màn, rèm, vật liệu phủ tường và sàn trong các cửa hàng chuyên doanh',
    value: '4753',
  },
  {
    label:
      'Bán lẻ đồ điện gia dụng, giường, tủ, bàn, ghế và đồ nội thất tương tự, đèn và bộ đèn điện, đồ dùng gia đình khác chưa được phân vào đâu  trong các cửa hàng chuyên doanh',
    value: '4759',
  },
  {
    label: 'Bán lẻ sách, báo, tạp chí văn phòng phẩm trong các cửa hàng chuyên doanh',
    value: '4761',
  },
  {
    label:
      'Bán lẻ băng đĩa âm thanh, hình ảnh (kể cả băng, đĩa trắng) trong các cửa hàng chuyên doanh',
    value: '4762',
  },
  {
    label: 'Bán lẻ thiết bị, dụng cụ thể dục, thể thao trong các cửa hàng chuyên doanh',
    value: '4763',
  },
  {label: 'Bán lẻ trò chơi, đồ chơi trong các cửa hàng chuyên doanh', value: '4764'},
  {
    label: 'Bán lẻ hàng may mặc, giày dép, hàng da và giả da trong các cửa hàng chuyên doanh',
    value: '4771',
  },
  {
    label:
      'Bán lẻ thuốc, dụng cụ y tế, mỹ phẩm và vật phẩm vệ sinh trong các cửa hàng chuyên doanh',
    value: '4772',
  },
  {label: 'Bán lẻ hàng hóa khác mới trong các cửa hàng chuyên doanh', value: '4773'},
  {label: 'Bán lẻ hàng hóa đã qua sử dụng trong các cửa hàng chuyên doanh', value: '4774'},
  {
    label: 'Bán lẻ lương thực, thực phẩm, đồ uống, thuốc lá, thuốc lào lưu động hoặc tại chợ',
    value: '4781',
  },

  {label: 'Bán lẻ hàng dệt, may sẵn, giày dép lưu động hoặc tại chợ', value: '4782'},
  {label: 'Bán lẻ thiết bị công nghệ thông tin liên lạc lưu động hoặc tại chợ', value: '4783'},
  {label: 'Bản lẻ thiết bị gia đình khác lưu động hoặc tại chợ', value: '4784'},
  {label: 'Bán lẻ hàng văn hóa, giải trí lưu động hoặc tại chợ', value: '4785'},
  {label: 'Bán  lẻ hàng hóa khác lưu động hoặc tại chợ', value: '4789'},
  {label: 'Bán lẻ theo yêu cầu đặt hàng qua bưu điện hoặc internet', value: '4791'},
  {label: 'Bán lẻ hình thức khác chưa được phân vào đâu', value: '4799'},
  {label: 'Vận tải hành khách đường sắt', value: '4911'},
  {label: 'Vận tải hàng hóa đường sắt', value: '4912'},
  {label: 'Vận tải hành khách bằng xe buýt trong nội thành', value: '4921'},
  {
    label: 'Vận tải hành khách bằng xe buýt giữa nội thành và ngoại thành, liên tỉnh',
    value: '4922',
  },
  {label: 'Vận tải hành khách bằng xe buýt loại khác', value: '4929'},
  {
    label: 'Vận tải hành khách đường bộ trong nội thành, ngoại thành (trừ vận tải bằng xe buýt)',
    value: '4931',
  },
  {label: 'Vận tải hành khách đường bộ khác', value: '4932'},
  {label: 'Vận tải hàng hóa bằng đường bộ', value: '4933'},
  {label: 'Vận tải đường ống', value: '4940'},
  {label: 'Vận tải hành khách ven biển và viễn dương', value: '5011'},
  {label: 'Vận tải hàng hóa ven biển và viễn dương', value: '5012'},
  {label: 'Vận tải hành khách đường thuỷ nội địa ', value: '5021'},
  {label: 'Vận tải hàng hóa đường thuỷ nội địa ', value: '5022'},
  {label: 'Vận tải hành khách hàng không', value: '5110'},
  {label: 'Vận tải hàng hóa hàng không', value: '5120'},
  {label: 'Kho bãi và lưu giữ hàng hóa', value: '5210'},
  {label: 'Hoạt động dịch vụ hỗ trợ trực tiếp cho vận tải đường sắt ', value: '5221'},
  {label: 'Hoạt động dịch vụ hỗ trợ trực tiếp cho vận tải đường thủy', value: '5222'},
  {label: 'Hoạt động dịch vụ hỗ trợ trực tiếp cho vận tải hàng không', value: '5223'},
  {label: 'Bốc xếp hàng hóa', value: '5224'},

  {label: 'Hoạt động dịch vụ hỗ trợ trực tiếp cho vận tải đường bộ', value: '5225'},
  {label: 'Hoạt động dịch vụ hỗ trợ khác liên quan đến vận tải', value: '5229'},
  {label: 'Bưu chính ', value: '5310'},
  {label: 'Chuyển phát', value: '5320'},
  {label: 'Dịch vụ lưu trú ngắn ngày', value: '5510'},
  {label: 'Cơ sở lưu trú khác', value: '5590'},
  {label: 'Nhà hàng và các dịch vụ ăn uống phục vụ lưu động', value: '5610'},
  {
    label: 'Cung cấp dịch vụ ăn uống theo hợp đồng không thường xuyên với khách hàng ',
    value: '5621',
  },
  {label: 'Dịch vụ ăn uống khác', value: '5629'},
  {label: 'Dịch vụ phục vụ đồ uống', value: '5630'},
  {label: 'Xuất bản sách', value: '5811'},
  {label: 'Xuất bản các danh mục chỉ dẫn và địa chỉ', value: '5812'},
  {label: 'Xuất bản báo, tạp chí và các ấn phẩm định kỳ ', value: '5813'},
  {label: 'Hoạt động xuất bản khác', value: '5819'},
  {label: 'Xuất bản phần mềm', value: '5820'},
  {
    label: 'Hoạt động sản xuất phim điện ảnh, phim video và chương trình truyền hình',
    value: '5911',
  },
  {label: 'Hoạt động hậu kỳ', value: '5912'},
  {
    label: 'Hoạt động phát hành phim điện ảnh, phim video và chương trình truyền hình',
    value: '5913',
  },
  {label: 'Hoạt động chiếu phim', value: '5914'},
  {label: 'Hoạt động ghi âm và xuất bản âm nhạc', value: '5920'},
  {label: 'Hoạt động phát thanh', value: '6010'},
  {label: 'Hoạt động truyền hình', value: '6021'},
  {label: 'Chương trình cáp, vệ tinh và các chương trình thuê bao khác', value: '6022'},
  {label: 'Hoạt động viễn thông có dây', value: '6110'},
  {label: 'Hoạt động viễn thông không dây', value: '6120'},
  {label: 'Hoạt động viễn thông vệ tinh', value: '6130'},
  {label: 'Hoạt động viễn thông khác', value: '6190'},
  {label: 'Lập trình máy vi tính', value: '6201'},
  {label: 'Tư vấn máy vi tính và quản trị hệ thống máy vi tính', value: '6202'},
  {
    label: 'Hoạt động dịch vụ công nghệ thông tin và dịch vụ khác liên quan đến máy vi tính ',
    value: '6209',
  },
  {label: 'Xử lý dữ liệu, cho thuê và các hoạt động liên quan', value: '6311'},
  {label: 'Cổng thông tin', value: '6312'},
  {label: 'Hoạt động thông tấn', value: '6391'},
  {label: 'Dịch vụ thông tin khác chưa được phân vào đâu', value: '6399'},
  {label: 'Hoạt động ngân hàng trung ương', value: '6411'},
  {label: 'Hoạt động trung gian tiền tệ khác', value: '6419'},
  {label: 'Hoạt động công ty nắm giữ tài sản', value: '6420'},
  {label: 'Hoạt động quỹ tín thác, các quỹ và các tổ chức tài chính khác', value: '6430'},
  {label: 'Hoạt động cho thuê tài chính', value: '6491'},
  {label: 'Hoạt động cấp tín dụng khác', value: '6492'},
  {
    label:
      'Hoạt động dịch vụ tài chính khác chưa được phân vào đâu (trừ bảo hiểm và bảo hiểm xã hội) ',
    value: '6499',
  },
  {label: 'Bảo hiểm nhân thọ', value: '6511'},
  {label: 'Bảo hiểm phi nhân thọ ', value: '6512'},
  {label: 'Bảo hiểm sức khỏe', value: '6513'},
  {label: 'Tái bảo hiểm', value: '6520'},
  {label: 'Bảo hiểm xã hội', value: '6530'},
  {label: 'Quản lý thị trường tài chính', value: '6611'},
  {label: 'Môi giới hợp đồng hàng hoá và chứng khoán', value: '6612'},
  {label: 'Hoạt động hỗ trợ dịch vụ tài chính chưa được phân vào đâu', value: '6619'},
  {label: 'Đánh giá rủi ro và thiệt hại', value: '6621'},
  {label: 'Hoạt động của đại lý và môi giới bảo hiểm', value: '6622'},
  {label: 'Hoạt động hỗ trợ khác cho bảo hiểm và bảo hiểm xã hội', value: '6629'},
  {label: 'Hoạt động quản lý quỹ', value: '6630'},
  {
    label: 'Kinh doanh bất động sản, quyền sử dụng đất thuộc chủ sở hữu, chủ sử dụng hoặc đi thuê ',
    value: '6810',
  },
  {label: 'Tư vấn, môi giới, đấu giá bất động sản, đấu giá quyền sử dụng đất', value: '6820'},
  {label: 'Hoạt động pháp luật', value: '6910'},
  {label: 'Hoạt động liên quan đến kế toán, kiểm toán và tư vấn về thuế', value: '6920'},
  {label: 'Hoạt động của trụ sở văn phòng ', value: '7010'},
  {label: 'Hoạt động tư vấn quản lý', value: '7020'},
  {label: 'Hoạt động kiến trúc và tư vấn kỹ thuật có liên quan', value: '7110'},
  {label: 'Kiểm tra và phân tích kỹ thuật', value: '7120'},
  {
    label: 'Nghiên cứu khoa học và phát triển công nghệ trong lĩnh vực khoa học tự nhiên',
    value: '7211',
  },
  {
    label:
      'Nghiên cứu khoa học và phát triển công nghệ trong lĩnh vực khoa học kỹ thuật và công nghệ',
    value: '7212',
  },
  {
    label: 'Nghiên cứu khoa học và phát triển công nghệ trong lĩnh vực khoa học y, dược',
    value: '7213',
  },
  {
    label: 'Nghiên cứu khoa học và phát triển công nghệ trong lĩnh vực khoa học nông nghiệp',
    value: '7214',
  },
  {
    label: 'Nghiên cứu khoa học và phát triển công nghệ trong lĩnh vực khoa học xã hội',
    value: '7221',
  },
  {
    label: 'Nghiên cứu khoa học và phát triển công nghệ trong lĩnh vực khoa học nhân văn',
    value: '7222',
  },
  {label: 'Quảng cáo', value: '7310'},
  {label: 'Nghiên cứu thị trường và thăm dò dư luận', value: '7320'},
  {label: 'Hoạt động thiết kế chuyên dụng', value: '7410'},
  {label: 'Hoạt động nhiếp ảnh', value: '7420'},
  {label: 'Hoạt động chuyên môn, khoa học và công nghệ khác chưa được phân vào đâu', value: '7490'},
  {label: 'Hoạt động thú y', value: '7500'},
  {label: 'Cho thuê xe có động cơ', value: '7710'},
  {
    label: 'Cho thuê máy móc, thiết bị và đồ dùng hữu hình khác không kèm người điều khiển',
    value: '7730',
  },
  {label: 'Cho thuê tài sản vô hình phi tài chính', value: '7740'},
  {
    label: 'Hoạt động của các trung tâm, đại lý tư vấn, giới thiệu và môi giới lao động, việc làm',
    value: '7810',
  },
  {label: 'Cung ứng lao động tạm thời', value: '7820'},
  {label: 'Cung ứng và quản lý nguồn lao động ', value: '7830'},
  {label: 'Đại lý du lịch', value: '7911'},
  {label: 'Điều hành tua du lịch', value: '7912'},
  {
    label: 'Dịch vụ đặt chỗ và các dịch vụ hỗ trợ liên quan đến quảng bá và tổ chức tua du lịch',
    value: '7990',
  },
  {label: 'Hoạt động bảo vệ tư nhân', value: '8010'},
  {label: 'Dịch vụ hệ thống bảo đảm an toàn', value: '8020'},
  {label: 'Dịch vụ điều tra', value: '8030'},
  {label: 'Dịch vụ hỗ trợ tổng hợp', value: '8110'},
  {label: 'Vệ sinh chung nhà cửa ', value: '8121'},
  {label: 'Vệ sinh công nghiệp và các công trình chuyên biệt', value: '8129'},
  {label: 'Dịch vụ chăm sóc và duy trì cảnh quan', value: '8130'},
  {label: 'Dịch vụ hành chính văn phòng tổng hợp', value: '8211'},
  {
    label: 'Photo, chuẩn bị tài liệu và các hoạt động hỗ trợ văn phòng đặc biệt khác',
    value: '8219',
  },
  {label: 'Hoạt động dịch vụ liên quan đến các cuộc gọi', value: '8220'},
  {label: 'Tổ chức giới thiệu và xúc tiến thương mại', value: '8230'},
  {label: 'Hoạt động dịch vụ hỗ trợ thanh toán, tín dụng', value: '8291'},
  {label: 'Dịch vụ đóng gói', value: '8292'},
  {label: 'Hoạt động dịch vụ hỗ trợ kinh doanh khác còn lại chưa được phân vào đâu', value: '8299'},
  {
    label:
      'Hoạt động của Đảng cộng sản, tổ chức chính trị - xã hội, hoạt động quản lý nhà nước nói chung và kinh tế tổng hợp',
    value: '8411',
  },
  {
    label:
      'Hoạt động quản lý nhà nước trong các lĩnh vực y tế, giáo dục, văn hoá và các dịch vụ xã hội khác (trừ bảo đảm xã hội bắt buộc)',
    value: '8412',
  },
  {label: 'Hoạt động quản lý nhà nước trong các lĩnh vực kinh tế chuyên ngành', value: '8413'},
  {label: 'Hoạt động đối ngoại', value: '8421'},
  {label: 'Hoạt động quốc phòng', value: '8422'},
  {label: 'Hoạt động an ninh, trật tự an toàn xã hội', value: '8423'},
  {label: 'Hoạt động bảo đảm xã hội bắt buộc', value: '8430'},
  {label: 'Giáo dục nhà trẻ', value: '8511'},
  {label: 'Giáo dục mẫu giáo', value: '8512'},
  {label: 'Giáo dục tiểu học', value: '8521'},
  {label: 'Giáo dục trung học cơ sở', value: '8522'},
  {label: 'Giáo dục trung học phổ thông', value: '8523'},
  {label: 'Đào tạo sơ cấp', value: '8531'},
  {label: 'Đào tạo trung cấp', value: '8532'},
  {label: 'Đào tạo cao đẳng', value: '8533'},
  {label: 'Đào tạo đại học', value: '8541'},
  {label: 'Đào tạo thạc sỹ', value: '8542'},
  {label: 'Đào tạo tiến sỹ', value: '8543'},
  {label: 'Giáo dục thể thao và giải trí', value: '8551'},
  {label: 'Giáo dục văn hoá nghệ thuật', value: '8552'},
  {label: 'Giáo dục khác chưa được phân vào đâu', value: '8559'},
  {label: 'Dịch vụ hỗ trợ giáo dục', value: '8560'},
  {label: 'Hoạt động của các bệnh viện, trạm y tế', value: '8610'},
  {label: 'Hoạt động của các phòng khám đa khoa, chuyên khoa và nha khoa', value: '8620'},
  {label: 'Hoạt động y tế dự phòng ', value: '8691'},
  {label: 'Hoạt động của hệ thống cơ sở chỉnh hình, phục hồi chức năng', value: '8692'},
  {label: 'Hoạt động y tế khác chưa được phân vào đâu', value: '8699'},
  {label: 'Hoạt động của các cơ sở nuôi dưỡng, điều dưỡng', value: '8710'},
  {
    label: 'Hoạt động chăm sóc sức khoẻ người bị thiểu năng, tâm thần và người nghiện',
    value: '8720',
  },
  {
    label:
      'Hoạt động chăm sóc sức khoẻ người có công, người già và người khuyết tật không có khả năng tự chăm sóc',
    value: '8730',
  },
  {label: 'Hoạt động chăm sóc tập trung khác', value: '8790'},
  {
    label:
      'Hoạt động trợ giúp xã hội không tập trung đối với người có công, thương bệnh binh, người già và người khuyết tật',
    value: '8810',
  },
  {label: 'Hoạt động trợ giúp xã hội không tập trung khác', value: '8890'},
  {label: 'Hoạt động sáng tác, nghệ thuật và giải trí ', value: '9000'},
  {label: 'Hoạt động thư viện và lưu trữ', value: '9101'},
  {label: 'Hoạt động bảo tồn, bảo tàng', value: '9102'},
  {label: 'Hoạt động của các vườn bách thảo, bách thú và khu bảo tồn tự nhiên', value: '9103'},
  {label: 'Hoạt động xổ số, cá cược và đánh bạc', value: '9200'},
  {label: 'Hoạt động của các cơ sở thể thao', value: '9311'},
  {label: 'Hoạt động của các câu lạc bộ thể thao', value: '9312'},
  {label: 'Hoạt động thể thao khác', value: '9319'},
  {label: 'Hoạt động của các công viên vui chơi và công viên theo chủ đề', value: '9321'},
  {label: 'Hoạt động vui chơi giải trí khác chưa được phân vào đâu', value: '9329'},
  {label: 'Hoạt động của các hiệp hội kinh doanh và nghiệp chủ', value: '9411'},
  {label: 'Hoạt động của các hội nghề nghiệp', value: '9412'},
  {label: 'Hoạt động của công đoàn', value: '9420'},
  {label: 'Hoạt động của các tổ chức tôn giáo', value: '9491'},
  {label: 'Hoạt động của các tổ chức khác chưa được phân vào đâu', value: '9499'},
  {label: 'Sửa chữa máy vi tính và thiết bị ngoại vi', value: '9511'},
  {label: 'Sửa chữa thiết bị liên lạc', value: '9512'},
  {label: 'Sửa chữa thiết bị nghe nhìn điện tử gia dụng', value: '9521'},
  {label: 'Sửa chữa thiết bị, đồ dùng gia đình', value: '9522'},
  {label: 'Sửa chữa giày, dép, hàng da và giả da', value: '9523'},
  {label: 'Sửa chữa giường, tủ, bàn, ghế và đồ nội thất tương tự', value: '9524'},
  {
    label: 'Sửa chữa xe đạp, đồng hồ, đồ dùng cá nhân và gia đình khác chưa được phân vào đâu',
    value: '9529',
  },
  {
    label:
      'Dịch vụ tắm hơi, massage và các dịch vụ tăng cường sức khoẻ tương tự (trừ hoạt động thể thao)',
    value: '9610',
  },
  {label: 'Giặt là, làm sạch các sản phẩm dệt và lông thú', value: '9620'},
  {label: 'Cắt tóc, làm đầu, gội đầu ', value: '9631'},
  {label: 'Hoạt động dịch vụ phục vụ tang lễ', value: '9632'},
  {label: 'Hoạt động dịch vụ phục vụ hôn lễ', value: '9633'},
  {label: 'Hoạt động dịch vụ phục vụ cá nhân khác còn lại chưa được phân vào đâu', value: '9639'},
  {label: 'Hoạt động làm thuê công việc gia đình trong các hộ gia đình', value: '9700'},
  {label: 'Hoạt động sản xuất các sản phẩm vật chất tự tiêu dùng của hộ gia đình', value: '9810'},
  {label: 'Hoạt động sản xuất các sản phẩm dịch vụ tự tiêu dùng của hộ gia đình', value: '9820'},
  {label: 'Hoạt động của các tổ chức và cơ quan quốc tế', value: '9900'},
]
